import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getDraftGiveawaySession = async (sessionId) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/productivity-host/briefs/giveaways/histories/${sessionId}` });

  return data;
};

export default getDraftGiveawaySession;
